module.exports = "/img/41.ae4127.webp";